<mat-card>
    <mat-card-content>
        <a mat-raised-button [routerLink]="['createParent']">Create Service Estimate</a>
        <a mat-raised-button [routerLink]="['create']">Create Sevice Estimate Component</a>
    </mat-card-content>
</mat-card>